export default __webpack_public_path__ + "static/media/room_bg_4.70ef5b27.jpg";